import { Link } from "react-router-dom";
import Footer from "./Footer";
const Bases = () => {
    return (
        <>
           <div className="fondoBases">
           <div className="container pt-5">
                <div className="row d-flex justify-content-center ">
                    <div className="col-sm-7 contenedorBases">
                    <h1 className="text-center mb-5 tituloBases">BASES</h1>
                        <ul className="textosBases">
                            <li><h5>Para poder participar deberás ser cuentahabiente de Martha Debayle, si aun no lo eres puedes obtener tu número en <a className="url" href="https://www.marthadebayle.com/" target="blank"> marthadebayle.com.</a></h5></li><br/>
                            <li><h5>Registra tus datos de contacto: Nombre completo, teléfono, correo electrónico, ID de cuentahabiente, estado y la foto de tu árbol de navidad decorado.</h5></li><br/>
                            <li><h5>El staff de Martha Debayle elegirá a los ganadores que se llevarán varias alegrías.</h5></li><br/>
                        </ul>
                    </div>                   
                </div>
                <div className="col-12 text-center pb-5">
                <Link className="btn botonResgistro text-uppercase" to="/Registro">REGÍSTRATE</Link>
                <Link className="btn botonResgistro text-uppercase" to="https://mmkg.net/registro" target="_blank">Crea tu ID</Link>
                </div>

            </div>
           </div>
            <Footer/>
        </>
    )
}
export default Bases;